import findIndex from 'lodash/findIndex';
import { useEffect, useState } from 'react';
import { PRICES_EVENTS } from '../constants/CONTROLLERS_EVENT_TYPES';
import useBasketSize from './useBasketSize';
import useTranslate from './useTranslate';

const useSeatsSelector = () => {
  const { Widget } = window;
  const [colors, setColors] = useState({ ...Widget.pricesController.pricesColors });
  const [prices, setPrices] = useState([...Widget.pricesController.prices]);
  const [selectedPrices, setSelectedPrices] = useState(
    new Set(Widget.pricesController.selectedPrices),
  );
  const basketSize = useBasketSize();
  const { t, transliterate } = useTranslate();

  const updateColors = () => {
    setColors({ ...Widget.pricesController.pricesColors });
  };

  useEffect(() => {
    Widget.pricesController.addListener(PRICES_EVENTS.PRICES_PREVIEW_UPDATED, updateColors);

    return () => {
      Widget.pricesController.removeListener(PRICES_EVENTS.PRICES_PREVIEW_UPDATED, updateColors);
    };
  }, []);

  const updatePrices = () => {
    setPrices([...Widget.pricesController.prices]);
    setSelectedPrices(new Set(Widget.pricesController.selectedPrices));
  };

  useEffect(() => {
    Widget.pricesController.addListener(PRICES_EVENTS.TOGGLE_PRICE, updatePrices);
    return () => {
      Widget.pricesController.removeListener(PRICES_EVENTS.TOGGLE_PRICE, updatePrices);
    };
  }, []);

  const faded = (price: number) => {
    if (!selectedPrices.size) return false;
    const index = findIndex(prices, (pricesArr) => pricesArr.indexOf(price) >= 0);
    return !selectedPrices.has(index);
  };

  return {
    colors,
    basketSize,
    transliterate,
    t,
    faded,
  };
};

export default useSeatsSelector;
